<template>
  <div class="animated fadeIn">
   
    <b-row>
      <b-col sm="12">
        <b-card header-tag="header" footer-tag="footer">
          <div slot="header">
            <strong> Print Sticker</strong> 

          </div>


          <b-row>
           <b-col md="12" >
    
           <div>
            <ul class="nav nav-tabs nav-justified">
             
             

              <li class="nav-item">
                <a @click="activeTab = 1"  class="nav-link" :class="{'active' : isActiveTab(1)}" >All</a>
              </li>

              <li class="nav-item">
                <a @click="activeTab = 2"  class="nav-link " :class="{'active' : isActiveTab(2)}">In Pallet</a>
              </li>
              <li class="nav-item">
                <a @click="activeTab = 3"  class="nav-link" :class="{'active' : isActiveTab(3)}" > Out Pallet</a>
              </li>
             
            </ul>
          </div>
           
          </b-col>
          <b-col md="12" >
       

            <div class="tab-panel" v-if="isActiveTab(1)">
            <printstickerall style="width:70%;"></printstickerall>
            </div>

            <div class="tab-panel" v-if="isActiveTab(2)">
              <printstickerin style="width:70%;"></printstickerin>
            </div>

            <div class="tab-panel" v-if="isActiveTab(3)">
            <printstickerout style="width:70%;" ></printstickerout>
            </div>
     
        
             </b-col>

          </b-row> 
        </b-card>
       
      </b-col>
    </b-row> 
  </div>   


</template>
<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";

import printstickerall from './printstickerall.vue'
import printstickerin from './printstickerin.vue'

import printstickerout from './printstickerout.vue'

export default {
  data: function() {
    return {
      // activeTab: '',
      activeTab: 1,
      printstickerall,
      printstickerin,
      printstickerout,
      name: 'printsticker'
     
    };
  },
  components: {
   

    printstickerall,
    printstickerin,
   printstickerout
  },
 created: function() {
    this.isActiveTab(1);
  },
 
  methods: {
    isActiveTab(id)

    {
      
       return this.activeTab === id
    },



    

  },
  filters: {
    capitalize: function(value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  }




  

};
</script>
